import React from 'react';
import { Button } from '../../components/Button';
/** Inlined size options — owned by this page only. */
const OPTIONS = ['Size 0 Red (Out of Stock Can order)', 'Size 0 Blue (Out of Stock Can order)', 'Size 1 Red (2 Reds In Stock)', 'Size 1 Blue (3 Blues In Stock)', 'Size 2 Red (1 Red In Stock) (+$20.00)', 'Size 2 Blue (2 Blue In Stock) (+$20.00)', 'Size 3 Red (OUT OF STOCK inquiry) (+$20.00)', 'Size 3 Blue (OUT OF STOCK inquiry) (+$20.00)', 'Size 4 Red (1 Red In Stock) (+$40.00)', 'Size 4 Blue (2 Blue In Stock) (+$40.00)', 'Size 5 Red (2 Red In Stock) (+$40.00)', 'Size 5 Blue (2 Blue In Stock) (+$40.00)'];
/**
 * Right-side purchase panel: size+quantity picker, dimensions, price,
 * and add-to-cart button. Self-contained.
 */
export function PurchasePanel() {
  return <div className="w-full md:w-1/2 flex flex-col" data-id="element-376">
      <h3 className="text-lg font-bold mb-4" data-id="element-377">Choose Size</h3>

      <div className="flex flex-col gap-2 mb-8" data-id="element-378">
        <div className="flex justify-end pr-2" data-id="element-379">
          <span className="text-xs font-bold text-gray-700" data-id="element-380">Qty</span>
        </div>
        {OPTIONS.map((option, idx) => <div key={idx} className="flex items-center justify-between gap-4 text-sm text-gray-700" data-id="element-381">
            <span className="flex-grow" data-id="element-382">{option}</span>
            <input type="number" min="0" defaultValue="0" className="w-16 px-2 py-1 border border-gray-300 rounded text-center focus:outline-none focus:ring-2 focus:ring-red-500" data-id="element-383" />
          </div>)}
      </div>

      <div className="text-center mb-6" data-id="element-384">
        <h4 className="font-bold text-gray-900 mb-1" data-id="element-385">Dimensions</h4>
        <p className="text-gray-700 mb-4" data-id="element-386">36 x 18 x 5</p>
        <p className="text-sm text-gray-500 mb-1" data-id="element-387">Your Price</p>
        <p className="text-2xl font-black text-gray-900 mb-4" data-id="element-388">$775.00</p>
        <Button variant="primary" className="bg-red-700 hover:bg-red-800 focus:ring-red-700 text-lg px-8 py-3" data-id="element-389">
          Add to Cart
        </Button>
      </div>
    </div>;
}